import { render, staticRenderFns } from "./DoorControl.vue?vue&type=template&id=fca154f4&"
import script from "./DoorControl.vue?vue&type=script&lang=js&"
export * from "./DoorControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports